import { BaseAction } from '../../store/actions';
import { AgentUpdatePayload, UserInfo, UserPayload } from '../../shared/models/user';

export enum ProfileActions {
  LoadUserProfileInfo = '[User] Load User Profile Info',
  LoadUserProfileInfoSucceed = '[User] Load User Profile Info Succeed',
  LoadUserProfileInfoFailed = '[User] Load User Profile Info Failed',
  UpdateUserProfileInfo = '[User] Update User Profile Info',
  UpdateUserProfileInfoSucceed = '[User] Update User Profile Info Succeed',
  UpdateUserProfileInfoFailed = '[User] Update User Profile Info Failed',
  ResetUserState = '[User] Reset State',
  ResetProfileSavingState = '[User] Reset Profile Saving State',
  UpdateUserInfo = '[User] Update User Info',
  UpdateUserInfoSucceed = '[User] Update User Info Succeed',
  UpdateUserInfoFailed = '[User] Update User Info Failed',
}

export class LoadUserProfileInfo implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.LoadUserProfileInfo;

  constructor(public readonly payload?: {
    isLoadAfterLogin: boolean,
    event: string
  }) { }
}

export class LoadUserProfileInfoSucceed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.LoadUserProfileInfoSucceed;

  constructor(public readonly payload: UserInfo) { }
}

export class LoadUserProfileInfoFailed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.LoadUserProfileInfoFailed;

  constructor(public readonly payload: string) {
  }
}

export class UpdateUserProfileInfo implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserProfileInfo;

  constructor(public readonly payload: {userId: number, body: UserPayload}) { }
}

export class UpdateUserProfileInfoSucceed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserProfileInfoSucceed;

  constructor(public readonly payload: UserInfo) { }
}

export class UpdateUserProfileInfoFailed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserProfileInfoFailed;

  constructor(public readonly payload: string) { }
}

export class ResetUserState implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.ResetUserState;
}

export class ResetProfileSavingState implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.ResetProfileSavingState;
}

export class UpdateUserInfo implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserInfo;

  constructor(public readonly payload: {userId: number, body: AgentUpdatePayload}) { }
}

export class UpdateUserInfoSucceed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserInfoSucceed;

  constructor(public readonly payload: UserInfo) { }
}

export class UpdateUserInfoFailed implements BaseAction<ProfileActions> {
  readonly type = ProfileActions.UpdateUserInfoFailed;

  constructor(public readonly payload: string) { }
}


export type ProfileAction = LoadUserProfileInfo | LoadUserProfileInfoSucceed | LoadUserProfileInfoFailed
  | UpdateUserProfileInfo | UpdateUserProfileInfoSucceed | UpdateUserProfileInfoFailed | ResetUserState | ResetProfileSavingState
  | UpdateUserInfo | UpdateUserInfoSucceed | UpdateUserInfoFailed;
